import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./modules/auth";
import list from "./modules/searchList";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		breadcrumb: [
			{
				id: "-1",
				menu_name: "首页",
				route: "/admin/home",
				path: "",
			},
		],
	},

	mutations: {
		pushBreadcrumb(state, data) {
			state.breadcrumb.push({ ...data });
		},
	},
	actions: {},
	modules: {
		auth,list
	},
	plugins: [
		createPersistedState({
			storage: window.sessionStorage,
			render(state) {
				return {
					breadcrumb: state.breadcrumb,
				};
			},
		}),
	],
});
